<template>
  <div>
    <v-row>
      <v-col>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                small elevation="0" fab color="primary"
                @click="sendAssignmentDialog = true"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span class="tooltip-text">ارسال فایل به مربی</span>
        </v-tooltip>
        آپلود فایل
      </v-col>
    </v-row>
    <v-row class="assignments-container">
      <v-col cols="12" v-for="assignment in assignments" :key="'assigment'+assignment.id">
        <div class="assignment-container">
          <v-row>
            <v-col cols="6" class="small-font pr-6">{{ assignment.title }}</v-col>
            <v-col cols="6" class="small-font text-left" v-if="assignment.item_file_title">
              فایل درس: {{ assignment.item_file_title }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="file-show-container text-center">
                <img v-if="assignment.attachment_type === 'image'"
                     :src="assignment.url" class="image-lesson"
                     :alt="assignment.title">
                <audio v-else-if="assignment.attachment_type === 'audio'"
                       :src="assignment.url" controls style="width: 100%"></audio>
                <video-player-mobile :options="videoOptions" source="onlineClassItem"
                                     v-else-if="assignment.attachment_type === 'video' && selectedVideoForShow.id === assignment.id && assignment.mime === 'm3u8'">
                </video-player-mobile>
                <div v-else-if="assignment.attachment_type === 'video' && selectedVideoForShow.id === assignment.id && assignment.mime === 'mp4'"
                     class="text-center">
                  <img width="100vh" height="75vh" src="@/assets/waiting.jpeg" alt="play video">
                  <br>
                  لطفا تا تبدیل ویدیو صبر کنید (چند دقیقه دیگر رفرش کنید).
                </div>
                <div v-else-if="assignment.attachment_type === 'video' && selectedVideoForShow.id !== assignment.id && assignment.mime !== 'mp4'"
                     @click="openVideo(assignment)" class="text-center">
                  <img width="100vh" height="100vh" src="@/assets/play-video.png" alt="play video">
                </div>
                <div v-else-if="assignment.attachment_type === 'video' && selectedVideoForShow.id !== assignment.id && assignment.mime === 'mp4'"
                     @click="openVideo(assignment)" class="text-center">
                  <img width="100vh" height="75vh" src="@/assets/waiting.jpeg" alt="play video">
                </div>
                <v-btn v-else style="letter-spacing: normal" width="100%"
                       color="primary"
                       @click="goTo(assignment.url)">مشاهده
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" class="my-5"></v-col>
            <v-col class="small-font text-left" cols="4" v-if="assignment.sent_by === 'admin'">فرستاده شده توسط مدیر</v-col>
            <v-col class="small-font text-left" cols="4" v-if="assignment.sent_by === 'student'">فرستاده شده توسط شما</v-col>
            <v-col class="small-font text-left" cols="4" v-if="assignment.sent_by === 'instructor'">فرستاده شده توسط مربی</v-col>
            <v-col cols="6" class="small-font text-right"> در
              {{ assignment.created_at_fa }}
            </v-col>
            <v-col class="text-right" cols="2" v-if="assignment.sent_by === 'student'">
              <v-icon color="error" @click="preDeleteAssignment(assignment.id)">mdi-trash-can-outline</v-icon>
            </v-col>

          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteAssignmentDialog" max-width="100vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            آیا از حذف این فایل اطمینان دارید؟
          </v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="deleteAssignment">
              بله
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" @click="deleteAssignmentDialog=false">
              خیر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendAssignmentDialog" max-width="100vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            <v-text-field
                color="black"
                label="عنوان"
                v-model="file.title">
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select
                color="black"
                label="این تمرین مربوط به کدام فایل درس است؟"
                :items="lessonFiles"
                item-value="id"
                item-text="title"
                v-model="file.item_file_id"
                :rules="[requiredLessonFileRule]"
                no-data-text="فایلی برای این درس پیدا نشد">
            </v-select>
          </v-col>
          <!--          <v-col cols="12">-->
          <!--            <v-select-->
          <!--                label="نوع فایل را مشخص کنید"-->
          <!--                :items="attachmentTypes"-->
          <!--                v-model="file.attachment_type"-->
          <!--                item-value="value"-->
          <!--                item-text="text"-->
          <!--                color="black"-->
          <!--            >-->
          <!--            </v-select>-->
          <!--          </v-col>-->
          <!--          <v-col cols="12">-->
          <!--            <v-text-field label="فایل"-->
          <!--                          disabled-->
          <!--                          color="black"-->
          <!--                          v-model="file.url">-->
          <!--            </v-text-field>-->
          <!--          </v-col>-->
          <v-col cols="12" v-if="!file.url">
            <drag-and-drop-mobile module="assignment" ref="image-uploader" @closeUploadFileDialog="fileDialog = false"
                                  @changeFile="file.url = $event"></drag-and-drop-mobile>
          </v-col>
          <v-col cols="12" v-else>
            با موفقیت آپلود شد.
            <v-icon x-large color="success">mdi-check</v-icon>
          </v-col>
          <v-col v-if="socialEnabled" cols="12">
            <v-checkbox v-model="shareToSocial" color="#6B35C8" label="این تمرین را در شبکه اجتماعی درک هم به اشتراک بگذار" hide-details />
            <v-select v-if="shareToSocial" v-model="shareAudience" :items="shareAudiences" item-text="text" item-value="value" label="چه کسانی تمرین را ببینند؟" />
          </v-col>
          <v-col cols="12">
            <v-btn block style="letter-spacing: normal" color="success" @click="send()">ارسال</v-btn>
          </v-col>
        </v-row>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import DragAndDropMobile from "@/components/Components/Mobile/UploadFile/DragAndDropMobile";
import VideoPlayerMobile from "@/components/Components/Mobile/Player/VideoPlayerMobile";

export default {
  name: "LessonAssignmentDesktop",
  components: {DragAndDropMobile, VideoPlayerMobile},
  props: {
    classId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
    lessonFiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      deleteAssignmentDialog: false,
      selectedAssignmentId: null,
      sendAssignmentDialog: false,
      fileDialog: false,
      assignments: [],
      socialEnabled: false,
      shareToSocial: false,
      shareAudience: 'class',
      shareAudiences: [{ text: 'هم‌کلاسی‌ها', value: 'class' }, { text: 'هم‌دوره‌ای‌ها', value: 'course' }, { text: 'همه هنرجویان درک', value: 'all' }, { text: 'عمومی با لینک اشتراک', value: 'public' }],
      file: {
        title: null,
        url: null,
        attachment_type: null,
        item_file_id: null,
      },
      attachmentTypes: [
        {value: 'audio', text: 'فایل صوتی'},
        {value: 'video', text: 'ویدیو'},
        {value: 'pdf', text: 'پی دی اف'},
        {value: 'image', text: 'تصویر'},
      ],
      selectedVideoForShow: {
        id: null
      },
      videoOptions: {
        autoplay: true,
        playbackRates: [0.5, 1, 1.5, 2, 4, 8],
        controls: true,
        liveui: true,
        responsive: true,
        sources: [
          {
            src: '',
            type: "application/vnd.apple.mpegurl"
          }
        ],
      },
    }
  },
  methods: {
    requiredLessonFileRule(value) {
      return Boolean(value) || 'انتخاب فایل درس الزامی است.'
    },
    goTo(path) {
      window.open(path)
    },
    openVideo(assignment) {
      this.selectedVideoForShow = assignment
      this.videoOptions.sources[0].src = assignment.url
    },
    getAssignments() {
      window.axios.get('student/assignment/index/' + this.classId + '/' + this.lessonId).then((res) => {
        this.assignments = res.data.data
      })
    },
    send() {
      if (!this.file.item_file_id) {
        this.openSnackbar('لطفا مشخص کنید تمرین مربوط به کدام فایل درس است.', '#F1416C')
        return
      }

      window.axios.post('student/assignment/create/' + this.classId + '/' + this.lessonId, this.file).then(async () => {
        this.getAssignments()
        let message = 'فایل شما با موفقیت ارسال شد.'
        if (this.shareToSocial) {
          try {
            const lessonFile = this.lessonFiles.find(item => item.id === this.file.item_file_id)
            const mediaType = /\.(mp4|mov|mkv|webm|avi)(\?|$)/i.test(this.file.url) ? 'video' : /\.(mp3|wav|ogg|aac|m4a|webm)(\?|$)/i.test(this.file.url) ? 'audio' : 'image'
            const result = await window.axios.post('student/social/posts', { post_type: 'practice', audience: this.shareAudience, online_class_id: this.classId, content: `تمرین تازه${lessonFile ? ' برای «' + lessonFile.title + '»' : ''}: ${this.file.title || 'تمرین موسیقی'}`, media_url: this.file.url, media_type: mediaType })
            message += result.data.status === 'pending' ? ' پست اجتماعی برای تأیید مربی ارسال شد.' : ' در شبکه اجتماعی هم منتشر شد.'
          } catch (_) { message += ' اما انتشار در شبکه اجتماعی انجام نشد.' }
        }
        this.openSnackbar(message, 'success')
        this.sendAssignmentDialog = false
        this.shareToSocial = false
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      }).finally(() => {
        this.file = {
          title: null,
          url: null,
          attachment_type: null,
          item_file_id: null,
        }
      })
    },
    preDeleteAssignment(assignmentId) {
      this.deleteAssignmentDialog = true
      this.selectedAssignmentId = assignmentId
    },
    deleteAssignment() {
      window.axios.delete('student/assignment/delete/' + this.selectedAssignmentId).then(() => {
        this.getAssignments()
        this.deleteAssignmentDialog = false
      })
    }
  },
  mounted() {
    this.getAssignments()
    window.axios.get('student/social/status').then(res => { this.socialEnabled = !!res.data.enabled }).catch(() => { this.socialEnabled = false })
  }
}
</script>

<style scoped>
.image-lesson{
  aspect-ratio: 1 !important;
  height: 20vh !important;
  width: 90%;
}
.assignments-container {
  height: 70vh !important;
  overflow-y: scroll !important;
  overflow-x: hidden!important;
}

.assignment-container {
  border-style: solid;
  border-color: #1ab69d;
  border-radius: 10px!important;
  height: 32vh !important;
}

.file-show-container {
  aspect-ratio: 1 !important;
  height: 10vh !important;
  width: 100%;
}
.small-font{
  font-size: 11px;
}
</style>
